import { api } from '../lib/api-client.js';

import type {
  CreateVendorCompanyInput,
  InviteVendorTechnicianInput,
  UpdateVendorCompanyInput,
  VendorTrade,
} from '@sitewise/shared';

export interface VendorCompanySummary {
  id: string;
  orgId: string;
  name: string;
  trade: VendorTrade;
  primaryContactName: string | null;
  primaryContactPhone: string | null;
  primaryContactEmail: string | null;
  addressLine1: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  notes: string | null;
  metadata: Record<string, unknown>;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
}

export interface VendorTechnicianSummary {
  id: string;
  name: string;
  email: string;
  isActive: boolean;
  lastLoginAt: string | null;
  emailVerifiedAt: string | null;
  createdAt: string;
}

export async function fetchVendorCompanies() {
  return api<{ vendorCompanies: VendorCompanySummary[] }>('/vendor-companies');
}

export async function createVendorCompany(body: CreateVendorCompanyInput) {
  return api<{ vendorCompany: VendorCompanySummary }>('/vendor-companies', {
    method: 'POST',
    body,
  });
}

export async function updateVendorCompany(id: string, body: UpdateVendorCompanyInput) {
  return api<{ vendorCompany: VendorCompanySummary }>(`/vendor-companies/${id}`, {
    method: 'PATCH',
    body,
  });
}

export async function archiveVendorCompany(id: string) {
  await api(`/vendor-companies/${id}`, { method: 'DELETE' });
}

export async function fetchVendorCompany(id: string) {
  return api<{ vendorCompany: VendorCompanySummary }>(`/vendor-companies/${id}`);
}

export async function fetchVendorCompanyTechnicians(id: string) {
  return api<{ technicians: VendorTechnicianSummary[] }>(
    `/vendor-companies/${id}/technicians`,
  );
}

export async function inviteVendorTechnician(
  companyId: string,
  body: InviteVendorTechnicianInput,
) {
  return api<{ technician: VendorTechnicianSummary }>(
    `/vendor-companies/${companyId}/technicians/invite`,
    { method: 'POST', body },
  );
}

export async function resendVendorTechnicianInvite(companyId: string, userId: string) {
  await api(`/vendor-companies/${companyId}/technicians/${userId}/resend-invite`, {
    method: 'POST',
  });
}

export async function deactivateVendorTechnician(companyId: string, userId: string) {
  await api(`/vendor-companies/${companyId}/technicians/${userId}/deactivate`, {
    method: 'POST',
  });
}
